import React, { useCallback, useMemo, useState } from 'react';
import { StyledItemList } from './StyledUpgrade';
import Text from '@molecules/Text';
import { BETab, BETabPanel, BETabs } from '@molecules/BETabs';
import AddonCard from '@view/components/Cards/Addon';
import { useStore } from '@data/other/withStore';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Accommodation, Addon } from '@data/models';
import { useNavigate, useParams } from 'react-router-dom';
import { Routes as AppRoutes } from '@view/routes';
import _ from 'lodash';
import Card from '@molecules/Card';
import { SessionTitle } from '../SessionTitle';

const Upgrade = () => {
  const navigate = useNavigate();

  const { property } = useStore();
  const { addons, accommodations, cart } = property;
  const { propertyCode } = useParams();
  const tablist = useMemo((): JSX.Element[] => {
    if (!accommodations.model || !addons.model) return [];
    const roomIds = [...new Set(addons.model.items.map((item) => item.roomId))];
    const tabs: JSX.Element[] = [];
    for (let i = 0; i < roomIds.length; i++) {
      const room = roomIds[i];
      tabs.push(
        <BETab id={`${room}`} panelId={`${room}`} key={room}>
          {accommodations.model.items.find((x) => x.id === room)?.name ||
            'Room ' + room}
        </BETab>
      );
    }
    return tabs;
  }, [accommodations.model, addons.model]);

  const rooms = useMemo(
    () =>
      cart.items
        .filter((x) => x.model?.type === 'accommodation')
        .map((x) => x.model?.item as Accommodation),
    [cart.items]
  );

  useEffect(() => {
    if (cart.items.length === 0) {
      navigate(`/${propertyCode}/${AppRoutes.Accommodations}`);
      return;
    }
  }, []);

  const onClickAdd = useCallback(
    (item: Addon, amount: number) => {
      cart.addAddon(item, amount);
    },
    [cart]
  );

  const onClickRemove = useCallback(
    (item: Addon) => {
      cart.removeAddon(item);
    },
    [cart]
  );

  return (
    <Card>
      <SessionTitle page={AppRoutes.Addons} title={'Addons'} />
      <Text type="card-body" size="lg">
        Enhance your stay with our special perks & upgrades.
        <br />
        Add-ons are on a per-room basis, please select the items individually
        for each accommodation below
      </Text>
      {tablist.length > 0 && (
        <BETabs
          activeTab={tablist.length > 0 ? tablist[0].props.id : ''}
          contentId="upgrades"
          tablist={tablist}
        >
          {rooms.map((room) => (
            <BETabPanel id={room.id} tabId={room.id} key={room.id}>
              <StyledItemList>
                {addons.model?.items
                  .filter((x) => x.roomId == room.id)
                  .map((item, index) => (
                    <>
                      <AddonCard
                        item={item}
                        key={index}
                        onClickAdd={onClickAdd}
                        onClickRemove={onClickRemove}
                      />
                    </>
                  ))}
              </StyledItemList>
            </BETabPanel>
          ))}
        </BETabs>
      )}
    </Card>
  );
};

export default observer(Upgrade);
